import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AddAddressModule,
  AddEmailAddressModule,
  AddSqaModule,
  CheckEmailModule,
  CreateMyPasswordModule,
  ForgotLoginModule,
  LoaderModule,
  LoginAuthenticationScreenModule,
  LoginHelpScreenModule,
  RecoverBySecurityQuestionsModule,
  RecoverYourAccountModule,
  RecoveryOptionsModule,
  ResetPasswordModule,
  UnlockYourAccountModule
} from '@com-delta-idp/mnx-login-ui';
import { FlyoutPositionDirective } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AppConfigMap, AppConfigService } from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { ExceptionTrackingService } from '../../data-access/login-modal/services/error-handling/exception-tracking.service';
import { LoginModalErrorHandlerService } from '../../data-access/login-modal/services/error-handling/login-modal-error-handler.service';
import { LoginModalComponent } from './login-modal.component';

export function initializeAppConfigFactory(
  service: AppConfigService
): () => Observable<Partial<AppConfigMap>> {
  const factory = () => service.initializeAppConfig();
  return factory;
}

@NgModule({
  declarations: [LoginModalComponent],
  imports: [
    CommonModule,
    LoginAuthenticationScreenModule,
    ReactiveFormsModule,
    UnlockYourAccountModule,
    RecoverYourAccountModule,
    LoginHelpScreenModule,
    ResetPasswordModule,
    RecoveryOptionsModule,
    ForgotLoginModule,
    AddSqaModule,
    CreateMyPasswordModule,
    RecoverBySecurityQuestionsModule,
    LoaderModule,
    CheckEmailModule,
    AddEmailAddressModule,
    AddAddressModule,
    FlyoutPositionDirective
  ],
  exports: [LoginModalComponent],
  providers: [
    LoginModalErrorHandlerService,
    ExceptionTrackingService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppConfigFactory,
      deps: [AppConfigService],
      multi: true
    },
    { provide: ErrorHandler, useExisting: LoginModalErrorHandlerService }
  ]
})
export class LoginModalModule {}
